import { trpc } from '@/shared/api/trpc';

export const useTravellerTypes = () =>
  trpc.travellerTypes.findAll.useQuery(
    { limit: 200, sort: 'title', order: 'asc' },
    { staleTime: 10 * 60 * 1000 }
  );
